import { createContext, useState, useEffect, ReactNode } from 'react';
import { useAuthenticatedFetch } from '../utils/auth-fetch';
import { useSnackbar } from './SnackbarContext';
import { useNavigate } from 'react-router-dom';
import { UserModel } from '../models/user.model';

interface UserContextType {
    currentUser: UserModel | null;
    setCurrentUser: (user: UserModel | null) => void;
}

const defaultValue: UserContextType = {
    currentUser: null,
    setCurrentUser: () => { }
};

const UserContext = createContext(defaultValue);


interface UserProviderProps {
    children: ReactNode;
}

const UserProvider = ({ children }: UserProviderProps) => {
    const [currentUser, setCurrentUser] = useState<UserModel | null>(null);
    const [renderKey, setRenderKey] = useState(0);

    const authenticatedFetch = useAuthenticatedFetch();
    const { showSnackbar } = useSnackbar();
    const navigate = useNavigate();

    useEffect(() => {
        if (localStorage.getItem('token')) {
            authenticatedFetch("/api/user/current").then(res => {
                if (res.ok) {
                    res.json().then(data => {
                        setCurrentUser(data);
                    });
                } else {
                    showSnackbar('Session expired. Please login again.', 'error');
                    setTimeout(() => {
                        setCurrentUser(null);
                        navigate('/');
                    }, 1000);
                }
            });
        } else {
            setTimeout(() => {
                setCurrentUser(null);
                navigate('/');
            }, 1000);
        }
    }, [renderKey]);

    useEffect(() => {
        setRenderKey(prev => prev + 1);
    }, [children]);

    return (
        <UserContext.Provider value={{ currentUser, setCurrentUser }}>
            {children}
        </UserContext.Provider>
    );
};

export { UserProvider, UserContext };
export type { UserContextType };
